import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

import ErrorField from '../ErrorField';
import FormLabel from '../Label';
import { SingleMultipleLayout } from '../SingleMultipleLayout';

import Checkbox from './CheckBox';

const CheckboxField = ({
  name,
  label,
  error,
  description,
  disabled = false,
  value,
  multiple = false,
  mb,
  width,
}) => {
  return (
    <SingleMultipleLayout multiple={multiple} mb={mb} width={width}>
      {label && <FormLabel label={label} error={error} name={name} />}
      <Checkbox
        name={name}
        description={description}
        error={error}
        disabled={disabled}
        value={value}
      />
      <ErrorMessage checkbox name={name} component={ErrorField} />
    </SingleMultipleLayout>
  );
};

CheckboxField.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  label: PropTypes.string,
  error: PropTypes.bool,
  description: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  mb: PropTypes.string,
  width: PropTypes.string,
};

export default CheckboxField;
